<template>
  <div class="row" v-show="is_loading">
    <div class="col-12 mt-3">
      <skeleton-box
        height="24px"
        width="100%"/>
    </div>
    <div class="col-3 mt-3" v-for="i in 4" :key="'skeleton-2-'+i">
      <skeleton-box
        height="50px"
        width="100%"/>
    </div>
    <div class="col-3 mt-3" v-for="i in 4" :key="'skeleton-3-'+i">
      <skeleton-box
        height="50px"
        width="100%"/>
    </div>
    <div class="col-3 mt-3" v-for="i in 4" :key="'skeleton-4-'+i">
      <skeleton-box
        height="50px"
        width="100%"/>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'

export default {
  props: ['is_loading',],
  components:{
    'skeleton-box': SkeletonBox,
  },
}
</script>
